import { useState } from 'react';
import { legacySportKey, isGrapplingSport, isStrikingSport, isCardioSport, isStrengthSport, sportCategory } from '../../data/sports';
import OverviewAnalysis from './OverviewAnalysis';
import GrapplingAnalysis from './GrapplingAnalysis';
import StrikingAnalysis from './StrikingAnalysis';
import WeightAnalysis from './WeightAnalysis';
import CardioAnalysis from './CardioAnalysis';

const TABS = [
    { key: 'overview', label: '전체' },
    { key: 'grappling', label: '그래플링' },
    { key: 'striking', label: '타격' },
    { key: 'weight', label: '웨이트' },
    { key: 'cardio', label: '유산소' },
];

function AnalysisDropdown({ options, value, onChange }) {
    const [open, setOpen] = useState(false);
    const selected = options.find(option => option.key === value) || options[0];
    if (!selected) return null;

    return (
        <div className="analysis-dropdown">
            <button className="analysis-dropdown-trigger" onClick={() => setOpen(v => !v)}>
                <span>{selected.label}</span>
                <em>{selected.count}개 기록</em>
                <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8">
                    <path d="M5 8l5 5 5-5" />
                </svg>
            </button>
            {open && (
                <div className="analysis-dropdown-menu">
                    {options.map(option => (
                        <button
                            key={option.key}
                            className={`analysis-dropdown-option${option.key === selected.key ? ' active' : ''}`}
                            onClick={() => {
                                onChange(option.key);
                                setOpen(false);
                            }}
                        >
                            <span>{option.label}</span>
                            <em>{option.count}개</em>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
}

export default function Analysis({ records, weights, promotions = [] }) {
    const [tab, setTab] = useState('overview');

    const grapplingRecs = records.filter(r => isGrapplingSport(legacySportKey(r)));
    const strikingRecs = records.filter(r => {
        const k = legacySportKey(r);
        return isStrikingSport(k) || sportCategory(k) === 'combat';
    });
    const weightRecs = records.filter(r => isStrengthSport(legacySportKey(r)));
    const cardioRecs = records.filter(r => isCardioSport(legacySportKey(r)));

    const counts = {
        overview: records.length,
        grappling: grapplingRecs.length,
        striking: strikingRecs.length,
        weight: weightRecs.length,
        cardio: cardioRecs.length,
    };
    const options = TABS
        .map(t => ({ ...t, count: counts[t.key] || 0 }))
        .filter(t => t.key === 'overview' || t.count > 0)
        .sort((a, b) => {
            if (a.key === 'overview') return -1;
            if (b.key === 'overview') return 1;
            return b.count - a.count;
        });
    const activeTab = options.some(option => option.key === tab) ? tab : 'overview';

    return (
        <>
            <AnalysisDropdown options={options} value={activeTab} onChange={setTab} />

            {activeTab === 'overview' && <OverviewAnalysis records={records} weights={weights} />}
            {activeTab === 'grappling' && <GrapplingAnalysis records={grapplingRecs} promotions={promotions} />}
            {activeTab === 'striking' && <StrikingAnalysis records={strikingRecs} />}
            {activeTab === 'weight' && <WeightAnalysis records={weightRecs} weights={weights} />}
            {activeTab === 'cardio' && <CardioAnalysis records={cardioRecs} />}
        </>
    );
}
